import type { JSX } from 'react'

export const PlusFavoriteIcon = (): JSX.Element => (
  <use href='#plusFavoriteIcon' height='100%' width='100%' />
)
